import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Model } from '../../../classes';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WsmanagerService } from '../../../services/wsmanager.service';
import { TranslateService } from '@ngx-translate/core';
import { WidgetsmanagerService } from '../../../services/widgetsmanager.service';
import { AlertController, ModalController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { ModelService } from 'src/app/services/model.service';
import { CategoryFlags, DeviceCategoryFlags } from 'src/app/classes/DeviceCategoryFlags';
import { EntityTypeEnum, ITranslation } from 'src/app/classes/ITranslation';
import { SettingsmanagerService } from 'src/app/services/settingsmanager.service';
import { Subscription } from 'rxjs';
import { TranslationModalComponent } from 'src/app/components/translation-modal/translation-modal.component';

enum ConnectorType {
  CONNECTOR1 = '0',
  CONNECTOR2 = '1'
}

@Component({
  selector: 'app-model-detail',
  templateUrl: './model-detail.component.html',
  styleUrls: ['./model-detail.component.scss']
})
export class ModelDetailComponent implements OnInit {
  @Input('device')
  public model: Model;
  categoryOptions: Array<{ key: any; label: string }> = [];
  public connectorType = [];
  public isSpinnerVisible = false;
  public isTranslationsLoading = false;
  public validation_messages: any;
  public modelForm: FormGroup;
  public sourceFilename = '';
  private sourceBlobFile;
  public sourceImageUrl;
  public CategoryFlags: typeof CategoryFlags = CategoryFlags;
  public DeviceCategoryFlags: typeof DeviceCategoryFlags = DeviceCategoryFlags;

  public translations: ITranslation[] = [];
  public subscriptions: Subscription[] = [];
  public entityType: EntityTypeEnum = EntityTypeEnum.Model;
  public entityId = -1;

  constructor(
    private formBuilder: FormBuilder,
    private wsManager: WsmanagerService,
    private translate: TranslateService,
    private _sanitizer: DomSanitizer,
    public alertController: AlertController,
    private _modelSvc: ModelService,
    private widgetsManager: WidgetsmanagerService,
    private modalController: ModalController,
    private cdr: ChangeDetectorRef,
    private settingsManager: SettingsmanagerService
  ) {
    this.categoryOptions = Object.keys(CategoryFlags)
      .filter(Number)
      .map((key) => ({
        key,
        label: CategoryFlags[key]
      }));
  }

  async ngOnInit() {
    if (!this.model) {
      // Creazione di un nuovo modello
      this.model = new Model();
    }

    // gestione foto del modello
    if (this.model.photoFile) {
      this.showImage(this.model.id);
    }

    console.log('Object.keys(ConnectorType): ', Object.keys(ConnectorType));
    for (const k of Object.keys(ConnectorType)) {
      this.connectorType.push(ConnectorType[k]);
    }
    console.log('this.connectorType: ', this.connectorType);

    console.log('this model: ', this.model);

    // init form
    this.entityId = +this.model.id;
    this.loadTranslationsByEntity();
    this.modelForm = this.formBuilder.group({
      id: [this.model.id],
      name: [this.model.name, [Validators.required]],
      description: [this.model.description, [Validators.required]],
      deviceCategory: [this.model.deviceCategory, [Validators.required, Validators.min(1)]],
      connectorType: [ConnectorType.CONNECTOR1],
      range_km: [this.model.range_km, []],
      cargoLoad: [this.model.cargoLoad, []],
      gCO2Km: [this.model.gCO2Km, []],
      wheelCount: [this.model.wheelCount, []],
      ratedPower: [this.model.ratedPower, []],
      supportsEpBattery: [this.model.supportsEpBattery, []],
      make: [this.model.make, []],
      model: [this.model.model, []],
      code: [this.model.code, []],
      seats: [this.model.seats ? this.model.seats : 1, [Validators.required]],
      photoFile: [this.sourceFilename]
    });

    this.validation_messages = {
      name: [{ type: 'required', message: 'This field is required.' }],
      description: [{ type: 'required', message: 'This field is required.' }],
      range_km: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      cargoLoad: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      gCO2Km: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      make: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      model: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      code: [
        { type: 'required', message: 'This field is required.' },
        { type: 'pattern', message: 'This field must contain a number.' }
      ],
      seats: [{ type: 'required', message: 'This field is required.' }],
      photoFile: [{ type: 'required', message: 'This field is required.' }],
      deviceCategory: [{ type: 'required', message: 'This field is required.' }]
    };
  }
  
  public async closePopover(reloadParent = false): Promise<void> {
    await this.modalController.dismiss(reloadParent);
  }

  async onSubmit(): Promise<void> {
    this.isSpinnerVisible = true;
    const isNew = !this.modelForm.value.id;
    this._modelSvc.save(this.modelForm.value, this.sourceBlobFile).subscribe(
      (savedModel) => {
        console.log('@@@ onSubmit EDIT OK @@@');
        this.isSpinnerVisible = false;
        // Update local model and form to reflect saved changes
        this.model = savedModel;
        this.modelForm.patchValue(savedModel);
        const actiondMsg = this.translate.instant(isNew ? 'Model added successfully.' : 'Model edited successfully.');
        this.widgetsManager.showToastMessage('success', actiondMsg);
        this.closePopover(true);
      },
      () => {
        this.isSpinnerVisible = false;
        const actiondMsg = this.translate.instant(isNew ? 'Error creating the model.' : 'Error editing the model.');
        this.widgetsManager.showToastMessage('danger', actiondMsg);
      }
    );
  }

  // traduzioni
  refreshContent(refreshEvent: { method: 'CREATE' | 'DELETE' | 'EDIT'; translation: ITranslation }) {
    const lang = this.settingsManager.getLanguageSetting();
    const { method, translation } = refreshEvent;
    switch (method) {
      case 'CREATE':
        this.translations.push(translation);
        this.translations = [...this.translations];
        break;
      case 'DELETE':
        this.translations = this.translations.filter((t) => t.id !== translation.id);
        break;
      case 'EDIT': {
        const index = this.translations.findIndex((t) => t.id === translation.id);
        this.translations[index] = translation;
        break;
      }
    }
    if (translation.locale === lang) {
      if (translation.value === '') {
        this.modelForm.get(translation.field).setValue(this.model[translation.field]);
      } else {
        this.modelForm.get(translation.field).setValue(translation.value);
      }
    }
  }

  changeEntityLanguage(language: string) {
    this.settingsManager.setLanguageSetting(language);
    const field = 'description';
    if (this.modelForm.get(field)) {
      this.modelForm.get(field).setValue(this.model[field]);
    }
    const localizedtranslations = this.translations.filter((t) => t.locale === language);
    localizedtranslations.forEach((lt) => {
      this.modelForm.get(lt.field).setValue(lt.value);
    });
  }

  loadTranslationsByEntity() {
    if (!this.entityId || this.entityId <= 0) {
      this.translations = [];
      this.isTranslationsLoading = false;
      this.cdr.detectChanges();
      return;
    }

    this.isTranslationsLoading = true;
    this.subscriptions.push(
      this.wsManager.fetchTranslations(this.entityType, this.entityId).subscribe(
        (response) => {
          console.log('@@@@@ translations by entity');
          this.translations = response;
          console.log('translations: ', this.translations);
          this.cdr.detectChanges();
        },
        (err) => {
          console.error('Error fetching translations:', err);
          this.isTranslationsLoading = false;
          this.cdr.detectChanges();
        },
        () => {
          this.isTranslationsLoading = false;
          this.cdr.detectChanges();
          console.log('Completed fetching translations.');
        }
      )
    );
  }

  async openTranslationsModal() {
    let rawEntityId: any = this.entityId;
    if (this.modelForm && this.modelForm.get('id')) {
      rawEntityId = this.modelForm.get('id').value;
    } else if (this.model && this.model.id) {
      rawEntityId = this.model.id;
    }
    const resolvedEntityId = Number(rawEntityId);
    if (!resolvedEntityId || resolvedEntityId <= 0) {
      return;
    }

    this.entityId = resolvedEntityId;
    this.isTranslationsLoading = true;
    this.subscriptions.push(
      this.wsManager.fetchTranslations(this.entityType, this.entityId).subscribe(
        async (response) => {
          this.translations = response;
          const onBackEmitter = new EventEmitter<void>();
          const modal = await this.modalController.create({
            component: TranslationModalComponent,
            cssClass: 'translation-modal',
            componentProps: {
              translations: this.translations,
              entityId: this.entityId,
              entityType: this.entityType,
              onBack: onBackEmitter,
              isPopover: true
            }
          });

          onBackEmitter.subscribe(() => {
            modal.dismiss();
            this.loadTranslationsByEntity();
            this.changeEntityLanguage(this.settingsManager.getLanguageSetting());
          });

          await modal.present();
        },
        (err) => {
          console.error('Error fetching translations:', err);
          this.isTranslationsLoading = false;
          this.cdr.detectChanges();
        },
        () => {
          this.isTranslationsLoading = false;
          this.cdr.detectChanges();
        }
      )
    );
  }

  chooseFile(event): void {
    this.sourceBlobFile = event.target.files[0];
    this.sourceFilename = this.sourceBlobFile.name;
    this.sourceImageUrl = this._sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(this.sourceBlobFile));
  }

  showImage(modelId): void {
    this._modelSvc.downloadImage(modelId).subscribe(
      (data) => {
        this.sourceBlobFile = data;
        this.sourceFilename = data.name;
        this.sourceImageUrl = this._sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(data));
        this.cdr.detectChanges();
      },
      (err) => {
        console.error("Errore durante la get dell'immagine", err);
        this.isSpinnerVisible = false;
        this.cdr.detectChanges();
      },
      () => {
        this.isSpinnerVisible = false;
        this.cdr.detectChanges();
      }
    );
  }

  async deleteModel(): Promise<void> {
    const alert = await this.alertController.create({
      header: this.translate.instant('Are you sure to proceed?'),
      buttons: [
        {
          text: this.translate.instant('Cancel'),
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Ok',
          handler: () => {
            console.log('Delete zone');
            this._modelSvc.delete(this.model.id).subscribe(
              () => {
                const msgOK = this.translate.instant('Model removed successfully.');
                this.widgetsManager.showToastMessage('success', msgOK);
                this.closePopover(true);
              },
              (err) => {
                console.log('ERR: ', err.message);
                const msgKO = this.translate.instant('Error removing the model.');
                this.widgetsManager.showToastMessage('danger', msgKO);
              }
            );
          }
        }
      ]
    });

    await alert.present();
  }

  public getLabelConnectorType(cod: number): string {
    const lbl = `add_device.connectortype_${cod}`;
    return lbl;
  }
}
